import { render, staticRenderFns } from "./LeftNavigation.vue?vue&type=template&id=d10966a0&scoped=true"
import script from "./LeftNavigation.vue?vue&type=script&lang=js"
export * from "./LeftNavigation.vue?vue&type=script&lang=js"
import style0 from "./LeftNavigation.vue?vue&type=style&index=0&id=d10966a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10966a0",
  null
  
)

export default component.exports